<template>
  <v-chip class="e-chip">
    <slot />

    <template v-if="closable" #append>
      <e-icon name="closeSvg" class="e-chip__close" size="16" @click="close" />
    </template>
  </v-chip>
</template>

<script setup lang="ts">
import { EIcon } from '@/core/components/ui';

defineProps<{
  closable?: boolean;
}>();

defineSlots<{
  default: (props: unknown) => void;
}>();

const emit = defineEmits<{
  (event: 'click:close'): void;
}>();

const close = () => {
  emit('click:close');
};
</script>

<style scoped lang="scss">
.e-chip {
  position: relative;
  z-index: 1;

  align-items: center;

  height: auto;
  padding: 8px 16px;

  line-height: 1.2;
  text-wrap-mode: initial;

  --v-activated-opacity: 1;

  &__close {
    color: $text-secondary-color;
  }

  :deep(.v-chip__underlay) {
    z-index: -1;

    background-color: $primary-light-color;
  }
}
.e-chip__close {
  margin: 0 -6px 0 11px;

  cursor: pointer;
}
</style>
